<div class="tabs">
  <ul>
    @for (title of titles; track title) {
      <li (click)="selectTab.emit(title)" [ngClass]="{ active: title == activeTitle }">
        {{ title }}
      </li>
    }
  </ul>
</div>
